var React = require('react');

function V2Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.80146 0C6.4324 0 6.98238 0.429409 7.13541 1.04151L8.00923 4.53678C8.15298 5.11181 7.91207 5.71424 7.41146 6.03159L5.61994 7.16727L5.82627 7.62075C7.58623 11.3494 10.5976 14.3714 14.3186 16.145L14.8342 16.3807L15.9686 14.5893C16.2858 14.0883 16.8885 13.8471 17.4638 13.9909L20.9585 14.8646C21.5706 15.0176 22 15.5676 22 16.1986V20.625C22 20.625 22 22 20.6259 21.9562C9.69858 21.2583 0.745798 12.3063 0.0442894 1.38131C2.95043e-05 0 1.37503 0 1.37503 0H5.80146Z"}));
}

V2Phone.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"current","stroke":"current"};

module.exports = V2Phone;

V2Phone.default = V2Phone;
